export default __webpack_public_path__ + "static/media/sidNew.94d69c26.jpg";